import { useError } from 'react-use';
import { useGraphql } from 'utils/hooks/useGraphql';
import { fetchBehavioralAudienceInsightSettings } from 'api/queries/customInsight';
import { BehavioralSettings } from 'modules/domains/segmentation';

type FetchBehavioralAudienceInsightSettings = {
  settings: BehavioralSettings[];
  maxBehavioralInsightSettingsForProject: number;
  success: boolean;
};

type CustomInsightsResponse = {
  fetchBehavioralInsightSettings: FetchBehavioralAudienceInsightSettings;
};

export const useCustomBehavioralInsightsQuery = () => {
  const dispatchError = useError();
  const { data, isLoading, error, refetch } = useGraphql<CustomInsightsResponse>(
    fetchBehavioralAudienceInsightSettings,
    { onError: dispatchError },
  );

  return {
    data: data?.fetchBehavioralInsightSettings,
    isLoading,
    isError: !!error || !data?.fetchBehavioralInsightSettings.success,
    isSuccess: !isLoading && !!data?.fetchBehavioralInsightSettings.success,
    refetch,
  };
};
